/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert between a centrifuge's speed (RPM) and its relative centrifugal force (RCF, or g-force). Enter the rotor radius and the value you know to get the other.`)
};

const es_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte entre la velocidad de una centrífuga (RPM) y su fuerza centrífuga relativa (RCF, o fuerza g). Introduce el radio del rotor y el valor que conoces para obtener el otro.`)
};

const de_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnen Sie zwischen der Drehzahl einer Zentrifuge (RPM) und ihrer relativen Zentrifugalkraft (RCF bzw. G-Kraft) um. Geben Sie den Rotorradius und den bekannten Wert ein, um den anderen zu erhalten.`)
};

const nl_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reken om tussen de snelheid van een centrifuge (RPM) en de relatieve centrifugale kracht (RCF, of g-kracht). Voer de rotorstraal en de bekende waarde in om de andere te berekenen.`)
};

const fr_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez entre la vitesse d'une centrifugeuse (RPM) et sa force centrifuge relative (RCF, ou force g). Entrez le rayon du rotor et la valeur connue pour obtenir l'autre.`)
};

const it_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti tra la velocità di una centrifuga (RPM) e la sua forza centrifuga relativa (RCF, o forza G). Inserisci il raggio del rotore e il valore che conosci per ottenere l'altro.`)
};

const pt_br2_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta entre a velocidade de uma centrífuga (RPM) e sua força centrífuga relativa (RCF, ou força g). Informe o raio do rotor e o valor que você conhece para obter o outro.`)
};

const pt_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta entre a velocidade de uma centrífuga (RPM) e a sua força centrífuga relativa (RCF, ou força g). Introduza o raio do rotor e o valor que conhece para obter o outro.`)
};

const ja_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遠心分離機の回転速度(RPM)と相対遠心力(RCF、g力)を相互に変換します。ローター半径とわかっている値を入力すると、もう一方の値が求められます。`)
};

const zh_gf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在离心机的转速（RPM）与相对离心力（RCF，即离心力）之间进行换算。输入转子半径和已知数值即可得到另一项结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_intro", locale)
	if (locale === "en") return en_gf_intro(inputs)
	if (locale === "es") return es_gf_intro(inputs)
	if (locale === "de") return de_gf_intro(inputs)
	if (locale === "nl") return nl_gf_intro(inputs)
	if (locale === "fr") return fr_gf_intro(inputs)
	if (locale === "it") return it_gf_intro(inputs)
	if (locale === "pt-BR") return pt_br2_gf_intro(inputs)
	if (locale === "pt") return pt_gf_intro(inputs)
	if (locale === "ja") return ja_gf_intro(inputs)
	return zh_gf_intro(inputs)
};